// This file defines the models and methods used by the message thread system.

// ------------------------------
// Message UI functionality
// ------------------------------

goog.provide('el8.appshared.message');

//goog.require('el8.appchart.mainFeeds.chart');
//goog.require('el8.appchart.mainFeeds.reqAct');
//goog.require('el8.appchart.mainFeeds.outstanding');
goog.require('el8.data.base');
goog.require('el8.service.tz');
goog.require('el8.uiwidget.alert');


el8.appshared.message = (function() {

    return {
        init : function(newMessageDialogObj) {

            var newMessageTriggerName;

            if(el8Globals['APP'] === 'chart') {
                newMessageTriggerName = '.message_trigger';
            } else if(el8Globals['APP'] === 'home') {
                newMessageTriggerName = '.new_message_trigger';
            } else {
                newMessageTriggerName = '#new_message_trigger';
            }

            // ------------------------------
            // Show forms
            // ------------------------------
            var newMessageDialog = null;
            function getNewMessageDialog() {
                if (!newMessageDialog) {
                    newMessageDialog = newMessageDialogObj();
                }
                return newMessageDialog;
            }

            el8.appshared.message.openSendNewMessageDialog = function(spec) {
                var originalSendCallbackFn = spec.sendCallbackFn;

                function sendCallbackFn(body, threadId, data) {
                    el8.ptdata.messageThreads.create(data);

                    if (originalSendCallbackFn) {
                        originalSendCallbackFn(body, threadId);
                    }
                }

                spec.sendCallbackFn = sendCallbackFn;

                if (spec.toDocId) {
                    var doc = el8.ptdata.fetch({
                        fetchId: spec.toDocId,
                        patientId: el8Globals['PATIENT_ID'] || spec.rePatientId
                    });
                    
                    var docId = doc.getId();

                    var docObj = {
                        doc: {
                            id: docId,
                            summary: doc.getNoteSummary(),
                            showLink: !!el8Globals['PATIENT_ID']
                        },
                        onClickDoc: function () {
                            el8.appchart.showItemDetail(docId);
                        }
                    };

                    el8React.dispatch.openSendNewMessageDialog(Object.assign({}, spec, docObj)); 
                }
                else {
                    el8React.dispatch.openSendNewMessageDialog(spec);
                }
            };

            el8.appshared.message.showNewMessageDialog = function() {
                if (el8Globals.FEATURES.NewOfficeMessages) {
                    el8.appshared.message.openSendNewMessageDialog({});
                }
                else {
                    getNewMessageDialog().show();
                }
            };

            el8.appshared.message.showReplyMessageForm = function( thread, container, spec) {
                if (el8Globals.FEATURES.NewOfficeMessages) {
                    var id = '#message-thread-reply-' + thread.getId();
                    var element = $(id, container);
                    var event = new Event('show-message-reply-form');

                    element[0].dispatchEvent(event);
                }
                else {
                    spec = spec || {};
                    spec.thread = thread;
                    spec.cardContainer = container;
                    el8.appshared.messageReplyForm(spec);
                }
            };

            if (!el8Globals['TEASE']) {
                $(document).find(newMessageTriggerName).off('click').on('click', function(e) {
                    e.preventDefault();
                    el8.appshared.message.showNewMessageDialog();
                });
            }
			// ------------------------------
			// Automatically display a new message form with contents pre-populated
			// ------------------------------
            el8.appshared.message.prePopulateNewMessage = function( spec ) {
                if ( !spec ) { spec = {}; }

                var autoSend = ( spec.autoSend === true );
                var toUsers = spec.toUsers || [];
                var toGroups = spec.toGroups || [];
                var callbackFn = spec.callbackFn || function() {};
                var body = spec.body || '';
                var toDocId = spec.toDocId || null;

                var dialog = getNewMessageDialog();
                if (autoSend) {
                    var sendFunction = el8Globals.FEATURES.NewOfficeMessages ? el8.appshared.message.openSendNewMessageDialog : dialog.sendMessage;

                    sendFunction({
                        toUsers: toUsers,
                        toGroups: toGroups,
                        body: body,
                        sendCallbackFn: callbackFn,
                        toDocId: toDocId
                    });
                } 
                else {
                    var showFunction = el8Globals.FEATURES.NewOfficeMessages ? el8.appshared.message.openSendNewMessageDialog : dialog.show;

                    showFunction({
                        rePatientId: spec.rePatientId || null,
                        toUsers: toUsers,
                        toGroups: toGroups,
                        body: body,
                        sendCallbackFn: callbackFn,
                        toDocId: toDocId
                    });
                }
            };

            el8.appshared.message.autoReply = function( container, thread, body, callbackFn, addTo) {

                el8.appshared.messageReplyForm({
                    cardContainer: container,
                    thread : thread,
                    autoSend : true,
                    autoSendBody : body,
                    autoSendAddTo : addTo,
                    callbackFn: callbackFn
                });

            };

            // ------------------
            // Ability to acknowledge thread and moved to addressed
            // ------------------
            el8.appshared.message.acknowledgeThread = function( thread, callbackFn ) {
                $.el8_ajax({
                    type: "POST",
                    url: el8.service.urls.get('acknowledgeMessageThread', [thread]),
                    data: {},
                    success: function(data) {
                        el8.ptdata.messageThreads.create(data);
                        if (callbackFn) { callbackFn(); }
                    }
                });
            };

            // ------------------
            // Acknowledging thread on behalf of everyone, to fix "stuck messages"
            // ------------------
            el8.appshared.message.acknowledgeThreadForAll = function( thread, callbackFn ) {
                $.el8_ajax({
                    type: "POST",
                    url: el8.service.urls.get('acknowledgeMessageThreadForAll', [thread]),
                    data: {},
                    success: function(data) {
                        el8.ptdata.messageThreads.create(data);
                        if (callbackFn) { callbackFn(); }
                    }
                });
            };
        }
    };
})();

el8.appshared.message.getPremadeResponseMenu = function(spec) {

    var item = spec.item || null;
    var addTo = spec.addTo || []; // list of users
    var callbackFn = spec.callbackFn || null;
    var closeFn = spec.closeFn || null;
    var container = spec.container || null;
    var menu = [];

    if (el8.model.identify.isReport(item)) {

        menu = el8.data.premadeMessages.all().map(function(m) {
            return {
                actionText: m.getBtnText(),
                actionFn: function() {
                    if (closeFn) { closeFn(); }
                    el8.appshared.message.prePopulateNewMessage({
                        toGroups: el8.data.currUser.getDefaultStaffGroupId() ? [el8.data.currUser.getDefaultStaffGroupId()] : [],
                        body: m.getBody(),
                        callbackFn: callbackFn,
                        toDocId: item ? item.getId() : null,
                        autoSend: true
                    });
                }
            };
        });

    } else if (el8.model.identify.isMessageThread(item)) {

        menu = el8.data.premadeMessages.all().map(function(m) {
            return {
                actionText: m.getBtnText(),
                actionFn: function() {
                    if (closeFn) { closeFn(); }
                    el8.appshared.message.autoReply(
                        container,
                        spec.item,
                        m.getBody(),
                        callbackFn,
                        addTo
                    );
                }
            };
        });
    }

    return menu;
};
